<template>
    <li class="monitoringUser">
        <span class="date">{{ date }}</span>
        <span class="name" :title="user.login">{{ user.login }}</span>
        <span class="path" :title="user.path">{{ user.path }}</span>
        <span class="inserted">{{ user.inserted }}</span>
        <span class="updated">{{ user.updated }}</span>
        <span class="deleted">{{ user.deleted }}</span>
    </li>
</template>

<script>
export default {
  name: 'MonitoringUser',
  props: {
    user: Object
  },
  computed: {
    date () {
      const date = new Date(this.user.date)
      return date.toLocaleString()
    }
  }
}
</script>

<style>
.monitoringUser{
  display:flex;
}
.monitoringUser span.date{
  flex:3 1 auto;
  color:grey;
}
.monitoringUser span.name{
  flex:3 1 auto;
  color:white
}
.monitoringUser span.path{
  flex:6 1 auto;
  color:grey;
  word-break:break-word;
}
.monitoringUser span.inserted{
  flex:1 1 auto;
  color:green;
}
.monitoringUser span.updated{
  flex:1 1 auto;
  color:blue;
}
.monitoringUser span.deleted{
  flex:1 1 auto;
  color:red;
}
</style>
